// import home from './home';
export default [
  {
  path: "/",
  redirect: 'home'
},
{
  path: "/",
  component: () => import("@/layouts/default.vue"),
  children: [
    {
      path: "/",
      redirect: "home"
    },
    {
      name: "home",
      path: "/home",
      // props: (route) => ({ query: route.query.menu_code }),
      meta: {
        title: "主页",
      },
      component: () => import("@/views/modules/home/index.vue")
    }
    // {
    //   name: "resource.statistics",
    //   path: 'statistics',
    //   component: () => import("./statistics/index.vue")
    // },
    // {
    //   name: "resource.leading",
    //   path: 'leading',
    //   component: () => import("./leading/resourseLead.vue")
    // }
  ]
  // children: [
  //   ...home,
  //   ...statistics
  // ]
}, {
  path: "/leadingResourse",
  name: "leadingResourse",
  component: () => import("./leading/leadingResourse.vue")
}, {
  path: "/leadingSmart",
  name: "leadingSmart",
  component: () => import("./leading/leadingSmart.vue")
}, {
  path: "/leadingSmartRe",
  name: "leadingSmartRe",
  component: () => import("./leading/leadReWrite.vue")
}, {
  path: "/statistics",
  name: "statistics",
  component: () => import("./statistics/index.vue")
}, {
  path: "/productHome",
  name: "productHome",
  component: () => import("./product/index.vue")
}, {
  path: "/roleManage",
  name: "roleManage",
  component: () => import("./roleManage/index.vue")
}, {
  path: "/menuManage",
  name: "menuManage",
  component: () => import("./roleManage/menu.vue")
}, {
  path: "/auth",
  name: "auth",
  component: () => import("./roleManage/auth.vue"),
  props: route => ({ role_id: route.query.role_id })
},
{
  path: "/entranceTeacher",
  name: "entranceTeacher",
  component: () => import("./entrance/teacher.vue")
}, {
  path: "/entranceJanitor",
  name: "entranceJanitor",
  component: () => import("./entrance/janitor.vue")
},{
  path: "/setting",
  name: "setting",
  component: () => import("./setting/index.vue")
}
];

// export default [{
//   path: "/",
//   redirect: "home"
// },{
//   name: "resource.home",
//   path: "home",
//   meta: {
//     title: "主页",
//   },
//   component: () => import("./index.vue")
// }];



// WEBPACK FOOTER //
// ./src/views/modules/index.js